import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@ledgerbook.in");
  const [password, setPassword] = useState("Admin@123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Welcome back");
      nav("/app");
    } else {
      toast.error(r.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left visual panel */}
      <div className="lb-auth-bg hidden md:flex flex-col justify-between p-10 relative overflow-hidden">
        <div className="flex items-center gap-2 relative z-10">
          <div className="w-8 h-8 rounded bg-white text-[#0A66C2] grid place-items-center font-extrabold text-lg">L</div>
          <div className="font-display font-extrabold text-xl tracking-tight text-white">LedgerBook Cloud</div>
        </div>
        <div className="relative z-10">
          <div className="font-display font-extrabold text-white text-5xl leading-[1.05] tracking-tight">
            Books that<br />balance themselves.
          </div>
          <p className="text-neutral-400 mt-4 max-w-md text-sm">
            GST‑compliant billing, e‑Invoice with IRN + QR, GSTR filing, and true double‑entry bookkeeping — for Indian businesses and CA firms.
          </p>
          <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
            {[
              { k: "e-Invoice", v: "IRN + QR" },
              { k: "Returns", v: "GSTR 1/3B/2B" },
              { k: "Recon", v: "Auto-match" },
            ].map((f) => (
              <div key={f.k} className="border border-neutral-700 p-3">
                <div className="text-[10px] uppercase tracking-wider text-neutral-500">{f.k}</div>
                <div className="font-mono text-white text-sm mt-1">{f.v}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-neutral-500 text-xs relative z-10 font-mono">
          ISO 27001 · GSTN Approved GSP · Made in India
        </div>

        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.08]" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '48px 48px'
        }} />
      </div>

      {/* Right form panel */}
      <div className="flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Sign in</div>
            <h1 className="font-display font-extrabold text-3xl tracking-tight mt-1">Welcome back</h1>
          </div>
          <div>
            <label className="lb-label">Email</label>
            <input type="email" className="lb-input" value={email} onChange={(e) => setEmail(e.target.value)}
                   data-testid="login-email" required />
          </div>
          <div>
            <label className="lb-label">Password</label>
            <input type="password" className="lb-input" value={password} onChange={(e) => setPassword(e.target.value)}
                   data-testid="login-password" required />
          </div>
          <button type="submit" disabled={loading} className="lb-btn w-full" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in →"}
          </button>
          <div className="text-sm text-neutral-500">
            No account?{" "}
            <Link to="/register" className="underline text-[#0A66C2] font-semibold" data-testid="link-register">Create one</Link>
          </div>

          <div className="border-t border-neutral-200 pt-4">
            <div className="text-[10px] uppercase tracking-widest text-neutral-500 font-semibold mb-2">
              Demo accounts (click to use)
            </div>
            <div className="grid grid-cols-1 gap-1.5 text-xs">
              {[
                { e: "admin@ledgerbook.in", p: "Admin@123", label: "Owner · India Demo", tag: "owner" },
                { e: "ca@ledgerbook.in", p: "Ca@12345", label: "Owner · CA Firm (Delhi)", tag: "owner" },
                { e: "global@ledgerbook.in", p: "Global@123", label: "Owner · USA (Global VAT)", tag: "owner" },
                { e: "accountant@ledgerbook.in", p: "Accountant@123", label: "Accountant · Demo Traders", tag: "accountant" },
                { e: "viewer@ledgerbook.in", p: "Viewer@123", label: "Viewer · Read-only", tag: "viewer" },
              ].map((d) => (
                <button key={d.e} type="button"
                        onClick={() => { setEmail(d.e); setPassword(d.p); }}
                        data-testid={`demo-${d.tag}-${d.e.split('@')[0]}`}
                        className="border border-neutral-200 p-2 text-left hover:border-[#0A66C2] hover:bg-neutral-50 transition-colors font-mono">
                  <div className="flex items-center justify-between">
                    <span className="text-neutral-900">{d.e}</span>
                    <span className={"lb-badge lb-badge-sm " + (
                      d.tag === "owner" ? "lb-badge-dark" :
                      d.tag === "accountant" ? "lb-badge-info" : ""
                    )} style={{fontSize: 9}}>{d.tag}</span>
                  </div>
                  <div className="text-[10px] text-neutral-500 mt-0.5">{d.label}</div>
                </button>
              ))}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
